import React from 'react'
import './Heading.css'

const Heading = ({thinText,boldText}) => {
  return (
    <div className='headingCon'>{thinText} <span> {boldText}</span></div>
  )
}

export default Heading